export { TableSortLabel } from './table-sort-label';
